import { FC } from "react";

import dynamic from "next/dynamic";

import { getLendingDataQuery } from "lib/sanity/queries";
import { getClient } from "lib/sanity/server";

import { RankedTableDataProps } from "components/ranked-table/types";
import ExploreMoreIntegrations from "components/views/integrations/explore-integrations";
import FeatureTable from "components/views/integrations/feature-table";
import { integrationDescriptions } from "components/views/integrations/integration-descriptions";
import PartnerWithEnerflo from "components/views/integrations/partner-with-enerflo";
import NonIntegratedLenders from "components/views/lendflo/non-integrated-lenders";

import Page from "../../components/layout/page";
import MainHero from "../../components/views/integrations/solar-finance/main-hero";

const Features = dynamic(() => import("../../components/views/integrations/lenders-chart"));
const DemoFormSection = dynamic(() => import("../../components/demo-form-section"));

const SolarFinance: FC<RankedTableDataProps> = props => (
  <Page
    title="Integrations for Solar Finance, TPO, Automated Escrow"
    description="Enerflo integrates with solar finance, payment and TPO providers, including Dividend, Palmetto LightReach, GoodLeap, PayKeeper, Sungage, Lumifi and more."
  >
    <MainHero />
    <FeatureTable title="Better Together: Give Your Customers a Choice When it Comes to Solar Finance">
      <Features {...props} />
    </FeatureTable>
    <NonIntegratedLenders />
    <ExploreMoreIntegrations
      items={[integrationDescriptions.sales, integrationDescriptions.design, integrationDescriptions.overview]}
    />
    <PartnerWithEnerflo />
    <DemoFormSection />
  </Page>
);

export default SolarFinance;

export async function getStaticProps(ctx) {
  const { preview = null } = ctx;

  const client = getClient(preview);
  let lendersData: RankedTableDataProps = {
    integratorsList: [],
    features: [],
  };

  try {
    lendersData = await client.fetch(getLendingDataQuery(preview));
  } catch (e) {
    console.error("Unable to fetch lenders data", e);
  }

  return {
    props: {
      preview,
      ...lendersData,
    },
  };
}
